'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _set_month = require('date-fns/set_month');

var _set_month2 = _interopRequireDefault(_set_month);

var _DatePickerDropdown = require('../DatePickerDropdown');

var _DatePickerDropdown2 = _interopRequireDefault(_DatePickerDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optionsOf = function optionsOf(items) {
  return items.map(function (item, index) {
    return { value: item, id: index };
  });
};

var MonthDropdown = function MonthDropdown(_ref) {
  var months = _ref.months,
      date = _ref.date,
      _onChange = _ref.onChange;

  var options = optionsOf(months);
  var selectedMonth = options.find(function (_ref2) {
    var id = _ref2.id;
    return id === date.getMonth();
  });

  return _react2.default.createElement(_DatePickerDropdown2.default, {
    dataHook: 'datepicker-month-dropdown',
    caption: selectedMonth.value,
    options: options,
    selectedId: selectedMonth.id,
    onChange: function onChange(_ref3) {
      var id = _ref3.id;
      return _onChange((0, _set_month2.default)(date, id));
    }
  });
};

MonthDropdown.propTypes = {
  months: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  date: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = MonthDropdown;